import { z } from 'zod';

export const transactionSchema = z.object({
  id: z.number(),
  g_id: z.string(),
  acc_id: z.number(),
  type: z.enum(['0', '1']), // 0 for deposit, 1 for withdraw
  amount: z.number(),
  description: z.string().nullable(),
  transaction_timestamp: z.iso.datetime(),
  entry_timestamp: z.iso.datetime(),
});

export type TransactionSchema = z.infer<typeof transactionSchema>;

export const transactionUpdateSchema = transactionSchema.omit({
  g_id: true,
  entry_timestamp: true,
});

export type TransactionUpdateSchema = z.infer<typeof transactionUpdateSchema>;

export const transactionCreateSchema = transactionUpdateSchema.omit({
  id: true,
});

export type TransactionCreateSchema = z.infer<typeof transactionCreateSchema>;

export const transactionFormSchema = transactionSchema
  .omit({
    g_id: true,
    entry_timestamp: true,
  })
  .extend({
    type: z.boolean(),
    transaction_timestamp: z.date({
      error: (issue) => (issue.input === undefined ? 'Please provide a valid transaction date.' : undefined),
    }),
    amount: z
      .number()
      .nullable()
      .refine(
        (v) => {
          const parsed = parseInt(`${v ?? 0}`.toString());
          return !isNaN(parsed) && parsed > 0;
        },
        {
          error: 'Amount must be greater than 0.',
        }
      ),
    description: z.string(),
  });

export type TransactionFormSchema = z.infer<typeof transactionFormSchema>;
